<template>
  <base-container
    ref="container"
    :isLoading="loading"
    style="display: flex; height: 100%; padding: 5px"
  >
    <artisan-group title="院区楼栋">
      <el-tree
        style="width: 220px; height: 100%"
        :data="hosBuildings"
        node-key="id"
        :props="{ label: 'name' }"
        default-expand-all
        :expand-on-click-node="false"
        @node-click="nodeClick"
      >
        <div
          style="
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 26px;
          "
          slot-scope="{ node, data }"
          :style="{
            backgroundColor: data.id == buildId ? '#C6E2FF' : '',
          }"
        >
          <span>
            <i
              v-if="!data.isHos"
              style="margin-right: 2px"
              class="el-icon el-icon-office-building color-primary"
            >
            </i>
            {{ node.label }}
          </span>
          <div>
            <el-button
              style="padding: 2px"
              v-if="data.isHos"
              icon="el-icon-plus"
              type="text"
              size="mini"
              @click="addBuilding(data)"
            >
            </el-button>
            <template v-else>
              <el-button
                style="padding: 0"
                type="text"
                size="mini"
                icon="el-icon-edit"
                @click="editBuilding(data)"
              >
              </el-button>
              <el-button
                style="padding: 0"
                type="text"
                size="mini"
                icon="el-icon-delete"
                @click="delBuilding(data)"
              >
              </el-button>
            </template>
          </div>
        </div>
      </el-tree>
    </artisan-group>
    <artisan-group title="楼栋楼层" style="margin: 0 5px">
      <template #header-right>
        <el-button
          style="padding: 0"
          type="text"
          size="mini"
          icon="el-icon-plus"
          :disabled="!buildId"
          @click="batchAddBuildLevel"
          >批量新增</el-button
        >
        <el-button
          style="margin-right: 5px; padding: 0"
          type="text"
          size="mini"
          icon="el-icon-plus"
          :disabled="!buildId"
          @click="addBuildLevel"
          >新增</el-button
        >
      </template>
      <div style="width: 220px">
        <draggable :animation="340" :list="buildLevels" handle=".movable">
          <div
            style="
              margin: 5px 0;
              padding: 5px 10px;
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
            :style="{
              backgroundColor:
                buildLevel.id == buildLevelId ? '#1989fa' : '#1989fa33',
            }"
            :class="
              buildLevel.id == buildLevelId ? 'color-white' : 'color-primary'
            "
            class="clickable movable"
            v-for="(buildLevel, index) in buildLevels"
            :key="buildLevel.id"
            @click="buildLevelId = buildLevel.id"
          >
            <span>{{ buildLevel.name }}</span>
            <div>
              <el-button
                type="text"
                size="mini"
                icon="el-icon-edit"
                @click="editBuildLevel(buildLevel)"
              >
              </el-button>
              <el-button
                type="text"
                size="mini"
                icon="el-icon-delete"
                @click="delBuilLevel(buildLevel, index)"
              >
              </el-button>
            </div>
          </div>
        </draggable>
        <el-button
          type="primary"
          size="small"
          v-show="buildLevels.length > 1"
          style="width: 100%; position: sticky; bottom: 0"
          @click="toSaveSort"
        >
          保存排序
        </el-button>
      </div>
    </artisan-group>
    <artisan-group title="科室分布" style="margin: 0 5px; flex: 1">
      <el-transfer
        :titles="['科室列表', '楼层科室']"
        v-model="deptIds"
        :data="deptList"
        @change="deptChange"
      ></el-transfer>
    </artisan-group>
  </base-container>
</template>

<script>
import { all } from "@/api/basis/hos";
import {
  list,
  add,
  batchAdd,
  saveSort,
  deptList,
  setDeptBuild,
  edit,
  remove,
} from "@/api/basis/building";
import draggable from "vuedraggable";
export default {
  components: { draggable },
  data() {
    return {
      loading: false,
      hosList: [],
      buildings: [],
      buildId: "",
      buildLevelId: "",
      buildLevels: [],
      showDialog: false,
      deptList: [],
      deptIds: [],
      bdMap: new Map(),
    };
  },
  computed: {
    hosBuildings() {
      let tree = [];
      this.hosList.forEach((c) => {
        let hos = Object.assign({ isHos: true, children: [] }, c);
        this.buildings
          .filter((b) => b.parentId == "0" && b.hosId == c.id)
          .forEach((b) => {
            hos.children.push(Object.assign({ isHos: false }, b));
          });
        tree.push(hos);
      });
      return tree;
    },
  },
  watch: {
    buildId() {
      this.loadBuildLevels();
    },
    buildLevelId() {
      this.deptIds = this.bdMap.get(this.buildLevelId);
    },
  },
  created() {
    all().then((res) => {
      this.hosList = res.data.data;
    });
    this.loadDept();
    this.loadBuild();
  },
  methods: {
    metaInited(option) {
      option.columns.forEach((c) => (c.isSearch = false));
      option.btns = [];
    },
    loadDept() {
      deptList().then((res) => {
        let { data } = res.data;
        let arr = [];
        this.bdMap = new Map();
        data.forEach((c) => {
          if (c.buildingIds) {
            let bids = c.buildingIds.split(",");
            bids.forEach((b) => {
              if (this.bdMap.has(b)) {
                this.bdMap.get(b).push(c.id);
              } else {
                this.bdMap.set(b, [c.id]);
              }
            });
          }
          arr.push({
            key: c.id,
            label: c.name,
            disabled: !c.isValid,
          });
        });
        this.deptList = arr;
      });
    },
    loadBuild() {
      list().then((res) => {
        this.buildings = res.data.data;
        console.log(this.buildings.length && !this.buildId);
        if (this.buildings.length && !this.buildId) {
          this.buildId = this.buildings[0].id;
        }
      });
    },
    loadBuildLevels() {
      if (this.buildId) {
        list(this.buildId).then((res) => {
          this.buildLevels = res.data.data;
          if (this.buildLevels.length) {
            this.buildLevelId = this.buildLevels[0].id;
          }
        });
      }
    },
    addBuilding(data) {
      this.$refs.container.prompt({ msg: "请输入楼栋名称！" }).then((val) => {
        if (!val) return;
        this.loading = true;
        add({
          name: val,
          hosId: data.id,
          hosName: data.name,
        })
          .then((res) => {
            this.loadBuild();
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    editBuilding(data) {
      this.$refs.container
        .prompt({ msg: "请输入楼栋名称！", value: data.name })
        .then((val) => {
          if (!val) return;
          this.loading = true;
          data.name = val;
          edit(data)
            .then((res) => {
              this.loadBuild();
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        });
    },
    delBuilding(data) {
      this.$refs.container
        .confirm({ msg: "请确认删除该楼栋【" + data.name + "】！" })
        .then(() => {
          this.loading = true;
          remove(data.id)
            .then((res) => {
              this.loadBuild();
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        });
    },
    nodeClick(data) {
      if (!data.isHos) {
        this.buildId = data.id;
      } else {
        this.buildId = "";
        this.buildLevels = [];
      }
    },
    levelClick(data) {
      this.buildLevelId = data.id;
    },
    batchAddBuildLevel() {
      this.$refs.container.prompt({ msg: "请输入楼栋层数？" }).then((val) => {
        if (isNaN(val)) return;
        this.loading = true;
        let parent = this.buildings.find((c) => c.id == this.buildId);
        let data = Object.assign({ buildLevels: [] }, parent);
        for (let index = 1; index <= val; index++) {
          data.buildLevels.push({
            name: index + "层",
            sortNo: index,
          });
        }
        batchAdd(data)
          .then((res) => {
            this.loadBuildLevels();
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    addBuildLevel() {
      this.$refs.container.prompt({ msg: "请输入楼栋名称？" }).then((val) => {
        if (!val) return;
        this.loading = true;
        let parent = this.buildings.find((c) => c.id == this.buildId);
        let data = Object.assign({}, parent);
        data.name = val;
        data.hosId = parent.hosId;
        data.hosName = parent.hosName;
        data.parentId = parent.id;
        add(data)
          .then((res) => {
            this.loadBuildLevels();
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    editBuildLevel(data) {
      this.$refs.container
        .prompt({ msg: "请输入楼栋名称！", value: data.name })
        .then((val) => {
          if (!val) return;
          this.loading = true;
          let params = Object.assign({}, data);
          params.name = val;
          edit(params)
            .then(() => {
              this.loading = false;
              data.name = val;
            })
            .catch(() => {
              this.loading = false;
            });
        });
    },
    delBuilLevel(data, index) {
      this.$refs.container
        .confirm({ msg: "请确认删除该楼层【" + data.name + "】！" })
        .then(() => {
          this.loading = true;
          remove(data.id)
            .then(() => {
              this.buildLevels.splice(index, 1);
              if (this.buildLevels.length)
                this.buildLevelId = this.buildLevels[0].id;
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        });
    },
    toSaveSort() {
      let sortList = [];
      for (let index = 0; index < this.buildLevels.length; index++) {
        const buildLevel = this.buildLevels[index];
        if (buildLevel.sortNo != index + 1) {
          buildLevel.sortNo = index + 1;
          sortList.push(buildLevel);
        }
      }
      if (sortList.length) {
        saveSort({
          buildLevels: sortList,
        }).then(() => {
          this.$message({
            message: "保存成功！",
            type: "success",
          });
        });
      }
    },
    deptChange() {
      this.loading = true;
      setDeptBuild(this.buildLevelId, this.deptIds.join(","))
        .then(() => {
          this.loading = false;
          this.$message({
            message: "设置成功！",
            type: "success",
          });
          this.loadDept();
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped></style>
